import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { clinicImgSrc } from "../../utils/constants";

function ClinicImageSlider() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [previewImages, setPreviewImages] = useState([]);
    const sliderRef = useRef(null);

    useEffect(() => {
        updatePreviewImages(currentSlide);
    }, [currentSlide]);

    const CustomNextArrow = ({ onClick }) => (
        <div className="clinic-img-arrow right" onClick={onClick}>
            <FaChevronRight />
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div className="clinic-img-arrow left" onClick={onClick}>
            <FaChevronLeft />
        </div>
    );

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        afterChange: (current) => setCurrentSlide(current)
    };

    const updatePreviewImages = (currentSlide) => {
        const prevIndex = (currentSlide - 1 + clinicImgSrc.length) % clinicImgSrc.length;
        const nextIndex = (currentSlide + 1) % clinicImgSrc.length;
        setPreviewImages([
            clinicImgSrc[prevIndex],
            clinicImgSrc[currentSlide],
            clinicImgSrc[nextIndex]
        ]);
    };
    return (
        <div className="clinic-img-slider-container">
            <Slider ref={sliderRef} {...settings}>
                {clinicImgSrc.map((imageUrl, index) => (
                    <div key={index} className='clinic-slide-item'>
                        <img src={imageUrl} alt={`Image ${index + 1}`} />
                    </div>
                ))}
            </Slider>
            <div className="clinic-small-img-div">
                <div onClick={() => sliderRef.current.slickPrev()}>
                    <img
                        className="clinic-small-image"
                        src={previewImages[0]}
                        alt=''
                    />
                </div>
                <div>
                    <img
                        className="clinic-small-image active"
                        src={previewImages[1]}
                        alt=''
                    />
                </div>
                <div onClick={() => sliderRef.current.slickNext()}>
                    <img
                        className="clinic-small-image"
                        src={previewImages[2]}
                        alt=''
                    />
                </div>
            </div>
        </div>
    );
}

export default ClinicImageSlider;

